import { styled } from "/stitches.config.js";
import { signIn } from "next-auth/react";
import { FcGoogle } from "react-icons/fc";

export default function SignIn({ error: errorType, callbackUrl, ...props }) {
  const errors = {
    Signin: "Try signing in with a different account.",
    OAuthSignin: "Try signing in with a different account.",
    OAuthCallback: "Try signing in with a different account.",
    OAuthCreateAccount: "Try signing in with a different account.",
    EmailCreateAccount: "Try signing in with a different account.",
    Callback: "Try signing in with a different account.",
    OAuthAccountNotLinked:
      "To confirm your identity, sign in with the same account you used originally.",
    EmailSignin: "The e-mail could not be sent.",
    CredentialsSignin:
      "Sign in failed. Check the details you provided are correct.",
    SessionRequired: "Please sign in to access this page.",
    default: "Unable to sign in.",
  };

  const error = errorType && (errors[errorType] ?? errors.default);

  return (
    <Container className="sign-in" {...props}>
      <div className="content">
        <img src="/logo.png" alt="Logo" />
        <div className="card">
          {error && (
            <div className="error">
              <p>{error}</p>
            </div>
          )}
          <div className="provider">
            <button onClick={() => signIn("google", { callbackUrl })}>
              <FcGoogle size="18" />
              Continue with Google
            </button>
          </div>
        </div>
        <div className="privacy">
          <span>By signing in, you agree to our </span>
          <a href="https://instashot.xyz/terms-of-service">terms of service</a>.
        </div>
      </div>
    </Container>
  );
}

SignIn.toString = () => ".sign-in";

const Container = styled("div", {
  ".content": {
    width: 510,
    borderRadius: 10,

    padding: "20px 0px",
    backgroundColor: "#212936",
    border: "2px",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    img: {
      height: 28,
      margin: "8px 0px",
    },
  },

  ".card": {
    width: 440,

    marginTop: 16,
    ".error": {
      width: "100%",
      display: "inline-block",
      color: "black",
      backgroundColor: "white",
      borderRadius: 4,
      marginBottom: 16,

      p: {
        textAlign: "center",
        margin: "8px 16px",
      },
    },
    button: {
      width: "100%",
      height: 42,
      fontSize: 14,
      background: "transparent",
      border: "1px solid #9d9d9d",
      borderRadius: 4,
      color: "white",
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      svg: {
        marginRight: 8,
      },
    },
  },

  ".privacy": {
    marginTop: 16,
    fontSize: 12,
    color: "#5E6574",
    a: {
      color: "#5856a0",
    },
  },
});

import { Dialog, DialogTrigger, DialogContent } from "./Dialog";

export function SignInDialog({ children, ...props }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <SignIn {...props} />
      </DialogContent>
    </Dialog>
  );
}
